import { PROD_CFW_ID, PROD_NORMAL_ID, QA_CFW_ID, QA_NORMAL_ID } from '@/constants/flights'
import { isUserSignedIn } from '../general/user'

export const isCfwFlow = ({ isLoginMandatory = false }) => {
    const isUserLoggedIn = isLoginMandatory ? true : true
    return isUserLoggedIn
}
export const getPartnerIdCfw = () =>{
    const isProd = process.env.NEXT_PUBLIC_CT_ENV === 'production' || process.env.NEXT_PUBLIC_CT_ENV === 'beta';
    return isProd ? PROD_CFW_ID : QA_CFW_ID
}
export const getPartnerId = (isCfw : boolean | string |undefined) => {
    const isCfwEnabled = isCfw === 'true' || isCfw === true
    if (isCfwEnabled) {
        return getPartnerIdCfw()
    }
    else {
        const isProd = process.env.NEXT_PUBLIC_CT_ENV === 'production' || process.env.NEXT_PUBLIC_CT_ENV === 'beta';
       return isProd ? PROD_NORMAL_ID : QA_NORMAL_ID
    }

}
export const extractChargeInfosFromPenalties = (penalties: any[]): any[] => {
    let chargeInfos: any[] = []
    penalties.forEach((penaltyObj: any) => {
        const { benefitList = [] } = penaltyObj || {}
        benefitList.forEach((benefit: any) => {
            const { details } = benefit || {}
            const { fareRules } = details || {}
            const { chargeInfos: extractedChargeInfos = [] } = fareRules || {}
            if (extractedChargeInfos && extractedChargeInfos.length > 0 && benefit.benefitType === 'AMEND') {
                chargeInfos = [...extractedChargeInfos]
            }
        })
    })
    return chargeInfos
}
